export default "__VITE_ASSET__CeJrVmlF__"